var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCommercialLowVoltage = function SvgCommercialLowVoltage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 4,
    fill: "#FFF9DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 39,
    width: 76,
    height: 42,
    rx: 4,
    fill: "#F8F8FB",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 49,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 49,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#FFD400",
    stroke: "#332C4A",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 58,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 58,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 58,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 58,
    width: 4,
    height: 4,
    rx: 2,
    fill: "#332C4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.18 28.323a.25.25 0 01-.25-.25V15.772a.25.25 0 00-.455-.144L46.86 33.65a.25.25 0 00.205.393h9.755a.25.25 0 01.25.25v12.302a.25.25 0 00.455.143l12.614-18.02a.25.25 0 00-.204-.394H60.18z",
    fill: "#FFD400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.14 28.717l-.82-.574.82.574zm-12.615 18.02l-.82-.573.82.573zM46.86 33.65l-.819-.574.82.574zm12.615-18.02l.82.573-.82-.574zm-.545.143v12.301h2V15.772h-2zm-11.25 18.45l12.614-18.02-1.638-1.147-12.615 18.02 1.639 1.147zm9.14-1.18h-9.755v2h9.755v-2zm1.25 13.552V34.292h-2v12.302h2zm11.25-18.45l-12.614 18.02 1.638 1.147L70.96 29.29l-1.639-1.148zm-9.14 1.18h9.755v-2H60.18v2zm10.779-.034a1.25 1.25 0 00-1.024-1.967v2a.75.75 0 01-.615-1.18l1.639 1.147zM56.07 46.594c0 1.222 1.573 1.718 2.274.717l-1.638-1.147c.42-.6 1.364-.303 1.364.43h-2zm.75-11.552a.75.75 0 01-.75-.75h2c0-.69-.56-1.25-1.25-1.25v2zm-10.779-1.967a1.25 1.25 0 001.024 1.967v-2a.75.75 0 01.615 1.18l-1.639-1.147zm12.889-5.002c0 .69.56 1.25 1.25 1.25v-2a.75.75 0 01.75.75h-2zm2-12.301c0-1.222-1.574-1.718-2.274-.717l1.638 1.147c-.42.6-1.364.303-1.364-.43h2z",
    fill: "#332C4A"
  })));
};

export default SvgCommercialLowVoltage;